import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/language/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/language/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.language.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: code => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, code });

            EditService.loadScreenView(
                code,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveLanguageAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_LANGUAGE_ASYNC, vo });

            EditService.saveLanguage(
                vo,
                response => {
                    dispatch(Actions.saveLanguageSuccess(response));
                },
                error => {
                    dispatch(Actions.saveLanguageFailure(error));
                }
            );
        };
    },

    saveLanguageSuccess: data => ({
        type: ActionTypes.SAVE_LANGUAGE_SUCCESS,
        parentType: ActionTypes.SAVE_LANGUAGE_ASYNC,
        data
    }),

    saveLanguageFailure: error => ({
        type: ActionTypes.SAVE_LANGUAGE_FAILURE,
        parentType: ActionTypes.SAVE_LANGUAGE_ASYNC,
        error
    }),

    createLanguage: () => ({
        type: ActionTypes.CREATE_LANGUAGE
    }),

    uploadLogoAsync: file => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPLOAD_LOGO_ASYNC, file });

            EditService.uploadLogo(
                file,
                response => {
                    dispatch(Actions.uploadLogoSuccess(response));
                },
                error => {
                    dispatch(Actions.uploadLogoFailure(error));
                }
            );
        };
    },

    uploadLogoSuccess: data => ({
        type: ActionTypes.UPLOAD_LOGO_SUCCESS,
        parentType: ActionTypes.UPLOAD_LOGO_ASYNC,
        postReducer: uploadLogoSuccessPostReducer,
        data
    }),

    uploadLogoFailure: error => ({
        type: ActionTypes.UPLOAD_LOGO_FAILURE,
        parentType: ActionTypes.UPLOAD_LOGO_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    language: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, language: data.language };
};

const uploadLogoSuccessPostReducer = (state, { data }) => {
    const { language } = state;
    return { ...state, language: { ...language, logo: data.virtualPath, imageUrl: data.absoluteUrl } };
};

const createLanguageReducer = (state) => {
    return { ...state, language: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_LANGUAGE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_LANGUAGE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_LANGUAGE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPLOAD_LOGO_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPLOAD_LOGO_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPLOAD_LOGO_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_LANGUAGE]: createLanguageReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
